<template>
  <div>
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane label="会员列表" name="first">
        <div>
          <div class="title_div">
            <span class="title-span">门店:</span>
            <el-select clearable  size="small" class="title-select"></el-select>
            <span class="title-span">会员等级:</span>
            <el-select clearable  size="small" class="title-select"></el-select>
            <span class="title-span">归属:</span>
            <el-select clearable  size="small" class="title-select"></el-select>
            <span class="title-span">开卡时间:</span>
            <el-date-picker
              v-model="hyStartDate"
              size="small"
              class="title-date1"
              type="date"
              placeholder="选择开始日期">
            </el-date-picker>
            至
            <el-date-picker
              v-model="hyEndDate"
              size="small"
              class="title-date2"
              type="date"
              placeholder="选择结束日期">
            </el-date-picker>
          </div>
          <div style="text-align: right">
            <el-button class="creat-button" type="primary" size="small">新建会员</el-button>
            <el-button class="out-button" type="primary" size="small">批量导出</el-button>
          </div>
          <div class="mm-tb">
            <el-table
              :data="hyTableData"
              style="width: 100%">
              <el-table-column
                prop="date"
                label="序号"
                align="center"
                width="80">
              </el-table-column>
              <el-table-column
                prop="name"
                label="会员姓名"
                align="center"
                width="160">
              </el-table-column>
              <el-table-column
                prop="address"
                label="手机号码"
                align="center"
                width="200"
              >
              </el-table-column>
              <el-table-column
                prop="address"
                label="会员等级"
                align="center"
                width="160"
              >
              </el-table-column>
              <el-table-column
                prop="address"
                label="会员积分"
                align="center"
                width="160"
              >
              </el-table-column>
              <el-table-column
                prop="address"
                label="门店"
                align="center"
                width="250"
              >
              </el-table-column>
              <el-table-column
                prop="address"
                label="归属人"
                align="center"
                width="160"
              >
              </el-table-column>
              <el-table-column
                prop="address"
                label="开卡日期"
                align="center"
                width="200"
              >
              </el-table-column>
              <el-table-column
                prop="address"
                align="center"
                label="操作">
              </el-table-column>
            </el-table>
          </div>
          <div>
            <el-pagination
              class="mm-page"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="hyCurrentPage"
              :page-size="100"
              layout="total,prev, pager, next, jumper"
              :total="1000">
            </el-pagination>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="会员营销" name="second">
        <div>
          <div class="title_div">
            <span class="title-span">门店:</span>
            <el-select clearable v-model="yxParams.shopId" size="small" class="title-select" @change="mdStortChange">
              <el-option v-for="item in this.mdSelectList" :label="item.name" :value="item.id"
                         :key="item.id"></el-option>
            </el-select>
            <span class="title-span">会员等级:</span>
            <el-select clearable v-model="yxParams.levelId" size="small" class="title-select" @change="djStortChange">
              <el-option v-for="item in this.djSelectList" :label="item.cardName" :value="item.id"
                         :key="item.id"></el-option>
            </el-select>
            <span class="title-span">归属:</span>
            <el-select clearable v-model="yxParams.userID" size="small" class="title-select" @change="dyStortChange">
              <el-option v-for="item in this.jlSelectList" :label="item.realname" :value="item.userId"
                         :key="item.userId"></el-option>
            </el-select>
            <span class="title-span">开卡时间:</span>
            <el-date-picker
              @change="hyStartChange"
              v-model="yxParams.createDateStart"
              size="small"
              class="title-date1"
              type="date"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              placeholder="选择开始日期">
            </el-date-picker>
            至
            <el-date-picker
              @change="hyEndChange"
              v-model="yxParams.createDateEnd"
              size="small"
              class="title-date2"
              type="date"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              placeholder="选择结束日期">
            </el-date-picker>
          </div>
          <div style="text-align: right">
            <!--            <el-button class="creat-button" type="primary" size="small">新建会员</el-button>-->
            <el-button class="out-button" type="primary" size="small">批量导出</el-button>
          </div>
          <div class="mm-tb">
            <el-table
              :data="yxTableData"
              style="width: 100%">
              <el-table-column
                prop="date"
                label="序号"
                align="center"
                width="80">
              </el-table-column>
              <el-table-column
                prop="userName"
                label="会员姓名"
                align="center"
                width="120">
              </el-table-column>
              <el-table-column
                prop="address"
                align="center"
                label="手机号码">
              </el-table-column>
              <el-table-column
                prop="levelName"
                align="center"
                label="会员等级">
              </el-table-column>
              <el-table-column
                prop="lastXiaoFeidt"
                align="center"
                label="上次消费">
              </el-table-column>
              <el-table-column
                prop="opdt"
                align="center"
                label="消费日期">
              </el-table-column>
              <el-table-column
                prop="consumptionCycle"
                align="center"
                label="消费周期">
              </el-table-column>
              <el-table-column
                prop="rollCase"
                align="center"
                label="用票情况">
              </el-table-column>
              <el-table-column
                prop="cumulativeVolume"
                align="center"
                label="累积用票">
              </el-table-column>
              <el-table-column
                prop="amount"
                align="center"
                label="消费金额">
              </el-table-column>
              <el-table-column
                prop="historyAmountCount"
                align="center"
                label="累积消费次数">
              </el-table-column>
              <el-table-column
                prop="historyAmount"
                align="center"
                label="累计消费金额">
              </el-table-column>
            </el-table>
          </div>
          <div>
            <el-pagination
              class="mm-page"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="yxCurrentPage"
              :page-size="100"
              layout="total,prev, pager, next, jumper"
              :total="1000">
            </el-pagination>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
  import {getAntMembersPage} from "../../api/MemberManagement";

  export default {
    name: "MemberManage",
    data() {
      return {
        activeName: 'first',
        yxParams: {
          createDateStart: "",
          createDateEnd: "",
          shopId: "",
          levelId: "",
          userID: "",
          pageNo: 1,
          pageSize: 10,
        },
      }
    },
    methods: {
      handleClick(tab, event) {
        console.log(tab, event);
      },
      //获取会员列表
      getAntMembersPage(params) {
        getAntMembersPage(params).then(res => {
          if (res.status === 200 && res.data.success) {
            if (res.data.result.total === 0) {
              this.$Notice.open({
                title: '查无数据'
              })
              this.hyResult = res.data.result
              this.hyList = res.data.result.records
            } else {
              this.hyResult = res.data.result
              this.hyList = res.data.result.records
            }
          } else {
            this.$message.error(res.data.message);
          }
        })
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
      },
      handleCurrentChange(val) {
        console.log(`当前页: ${val}`);
      },
      //会员开始时间改变
      hyStartChange(val) {
        this.getAntMembersPage(this.hyParams)
      },
      //会员结束时间改变
      hyEndChange(val) {
        this.getAntMembersPage(this.hyParams)
      },
    }
  }
</script>

<style scoped>
  .title-span {
    font-size: 16px;
  }

  .title_div {
    margin: 20px 30px;
  }

  .title-select {
    margin: 0 20px;
  }

  .title-date1 {
    margin-left: 20px;
    width: 180px;
  }

  .title-date2 {
    width: 180px;
  }

  .creat-button {
    margin: 20px;
  }

  .out-button {
    margin-top: 20px;
    margin-right: 80px;
    margin-bottom: 20px;
  }

  .mm-tb {
    width: 90%;
    margin-left: 50px;
  }

  .mm-page {
    margin: 30px 60px;
  }

</style>
